import styles from './ModalButton.module.scss';
import PulseSpinner from '../../spinner/PulseSpinner';

const BasicModalButton = ({ label, onClick, isLoading = false }) => {
  return (
    <div className={styles.BasicButtonContainer}>
      <button
        className={isLoading ? styles.DisabledButton : styles.SuccessButton}
        onClick={onClick}
        disabled={isLoading}>
        {isLoading
          ? <PulseSpinner isLoading={isLoading}/>
          : label
        }
      </button>
    </div>
  )
}

export default BasicModalButton;